export const formatUrl = (url: string) => {
  // Check if the URL starts with 'http://' or 'https://'
  if (!/^https?:\/\//i.test(url)) {
    // If not, prepend 'https://'
    return `https://${url}`;
  }
  // If it already has 'http://' or 'https://', return the URL as is
  return url;
};
